export enum PeriodDateTypeEnum {
  'Рабочий',
  'Календарный',
}
